import React, { useState } from "react";

import IconBtn from "src/components/icom-icon-btn";

import { Moon, Sun } from "src/assets/svgs";

interface IcomThemeSwitcherProps {
  currentTheme: string;
  setConfig: (config: any) => void;
  changeRegister: () => void | undefined;
}
const IcomThemeSwitcher: React.FC<IcomThemeSwitcherProps> = ({
  currentTheme,
  setConfig,
  changeRegister,
}) => {
  const [theme, setTheme] = useState(currentTheme);

  const handleTheme = (theme: string) => {
    changeRegister && changeRegister();
    setTheme(theme);
    setConfig({ theme });
  };

  return (
    <>
      <span className="text-sm font-bold text-neutral-gray-800 dark:text-neutral-gray-50">
        Tema
      </span>
      <div className="flex gap-3">
        <IconBtn
          onClick={() => handleTheme("light")}
          Icon={Sun}
          selected={theme == "light" ? true : false}
          type="button"
        />
        <IconBtn
          onClick={() => handleTheme("dark")}
          Icon={Moon}
          selected={theme == "dark" ? true : false}
          type="button"
        />
      </div>
    </>
  );
};

export default IcomThemeSwitcher;
